import { Validable } from "./common";
import { User } from "./user";
import { Attachment } from "./attachment";

const SAVE_PROPS = ['comment', 'created_by_id', 'attachments'];

export class TicketComment extends Validable {
    validationKey = "ticket_comment";

    comment: string;
    created_by_id: number;
    created_by: User;
    attachments: Attachment[];

    constructor(data) {
        super(data);
        this.setup_defaults();
    }

    private setup_defaults() {
        if (!this.attachments) {
            this.attachments = [];
        } else {
            this.attachments = this.attachments.map(a => new Attachment(a));
        }
    }

    appendAttachmentFromFile(file: File) {
        this.attachments.push(new Attachment({
            file: file,
            filename: file.name
        }));
    }

    get saveProp(): string[] {
        return super.saveProp.concat(SAVE_PROPS);
    }
}